<template>
  <v-dialog
    persistent
    v-model="dialogAddUser"
    :width="`${screenWidth}%`"
  >
    <div class="container-dialog">
      <close-dialog-component @closeDialog="closeDialog" />
      <p class="text-title mon-bold">{{ texts.users.dialogAddUser.textTitle }}</p>
      <v-text-field
        v-model="userName"
        type="text"
        :label="texts.users.dialogAddUser.textUserName"
        outlined
        color="#000000"
        dense
        class="global-inputs mon-regular"
        :placeholder="texts.users.dialogAddUser.textUserName"
        persistent-placeholder
        maxLength="40"
      ></v-text-field>
      <v-text-field
        v-model="userLastName"
        type="text"
        :label="texts.users.dialogAddUser.textUserLastName"
        outlined
        color="#000000"
        dense
        class="global-inputs mon-regular mt-5"
        :placeholder="texts.users.dialogAddUser.textUserLastName"
        persistent-placeholder
        maxLength="40"
      ></v-text-field>
      <v-text-field
        v-model="userEmail"
        type="text"
        :label="texts.users.dialogAddUser.textUserEmail"
        outlined
        color="#000000"
        dense
        class="global-inputs mon-regular mt-5"
        :placeholder="texts.users.dialogAddUser.textUserEmail"
        persistent-placeholder
        maxLength="85"
      ></v-text-field>
      <v-text-field
        v-model="userPosition"
        type="text"
        :label="texts.users.dialogAddUser.textUserPosition"
        outlined
        color="#000000"
        dense
        class="global-inputs mon-regular mt-5"
        :placeholder="texts.users.dialogAddUser.textUserPosition"
        persistent-placeholder
        maxLength="40"
      ></v-text-field>
      <v-text-field
        v-model="userPhoneNumber"
        type="text"
        :label="texts.users.dialogAddUser.textUserPhoneNumber"
        outlined
        color="#000000"
        dense
        class="global-inputs mon-regular mt-5"
        :placeholder="texts.users.dialogAddUser.textUserPhoneNumber"
        persistent-placeholder
        maxLength="13"
        @keypress="soloNumbers"
      ></v-text-field>
      <div
        v-if="isResponsive"
        class="mt-9"
      >
        <v-btn
          @click="addUser"
          elevation="0"
          :loading="bLoading"
          :disabled="!validateForm"
          class="button-primary mon-bold"
          style="width: 100%;"
        >
          {{ texts.users.dialogAddUser.textButtonAdd }}
        </v-btn>
        <v-btn
          @click="closeDialog"
          elevation="0"
          class="button-secondary mon-regular mt-5"
          style="width: 100%;"
        >
          {{ texts.users.dialogAddUser.textButtonCancel }}
        </v-btn>
      </div>
      <div
        v-else
        class="display-flex align-items-center mt-9"
      >
        <v-btn
          @click="closeDialog"
          elevation="0"
          class="button-secondary mon-regular"
        >
          {{ texts.users.dialogAddUser.textButtonCancel }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="addUser"
          elevation="0"
          :loading="bLoading"
          :disabled="!validateForm"
          class="button-primary mon-bold"
        >
          {{ texts.users.dialogAddUser.textButtonAdd }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "UsersDialogAddUserLayout",
  props: {
    texts: {
      type: Object,
    },
  },
  data() {
    return {
      userName: "",
      userLastName: "",
      userEmail: "",
      userPosition: "",
      userPhoneNumber: "",
      screenWidth: 0,
      bLoading: false,
      isResponsive: false,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    soloNumbers: function (evt) {
      if (
        (evt.which != 8 && evt.which != 0 && evt.which < 48) ||
        evt.which > 57
      ) {
        evt.preventDefault();
      }
    },
    handleResize: function () {
      if (window.innerWidth >= 600) {
        this.screenWidth = 40;
      } else {
        this.screenWidth = 100;
      }

      if (window.innerWidth < 960) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
    closeDialog: function () {
      this.$store.commit("setDialogAddUser", false);
      this.userName = "";
      this.userLastName = "";
      this.userEmail = "";
      this.userPosition = "";
      this.userPhoneNumber = "";
    },
    addUser: function () {
      this.bLoading = true;

      const payload = {
        sName: this.userName,
        sLastname: this.userLastName,
        sEmail: this.userEmail,
        sPhoneNumber: this.userPhoneNumber,
        sPositionName: this.userPosition,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/vendors/enterprises/${this.$store.state.sEnterpriseId}/employees`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;

          this.mixSuccess(response.data.message);
          this.closeDialog();
          this.$store.commit("refresher", true);
        })
        .catch((error) => {
          this.bLoading = false;

          this.mixError(error.response.data.message, error.response.status);
        });
    },
  },
  computed: {
    // return create contact dialog state
    dialogAddUser() {
      return this.$store.state.dialogAddUser;
    },
    selectLanguage() {
      return this.$store.state.language;
    },
    validateForm: function () {
      return (
        this.userName !== "" &&
        this.userLastName !== "" &&
        this.userEmail !== "" &&
        this.userPosition !== "" &&
        this.userPhoneNumber !== "" &&
        this.userName !== null &&
        this.userLastName !== null &&
        this.userEmail !== null &&
        this.userPosition !== null &&
        this.userPhoneNumber !== null
      );
    },
  },
  watch: {
    dialogAddUser() {
      if (this.dialogAddUser) {
        // this.texts = FILE.users[this.selectLanguage];
      }
    },
    selectLanguage: function () {
      if (this.selectLanguage) {
        // this.texts = FILE.users[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.container-dialog {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  opacity: 1;
  padding: 25px;
  position: relative;
}

.text-title {
  text-align: center;
  letter-spacing: 0px;
  color: #283c4d;
  opacity: 1;
  font-size: 20px;
}
</style>